const getPatientDeliveryNotes = ({ patient, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }

  if (patient['Patient Global Notes']) {
    return patient['Patient Global Notes']
      .filter(item => item['Notes Category'].filter(category => category['Is Delivery']).length > 0)
      .map(item => `${item.Text};`)
      .join('\n');
  }
  return '';
};

export default getPatientDeliveryNotes;



// WEBPACK FOOTER //
// ./src/utils/print/getPatientDeliveryNotes.js